module.exports = __webpack_public_path__ + "assets/img/6_608_big.70f5247c.jpg";